import React from 'react';
import HeaderContainer from 'containers/header';
import ErrorContainerNotify from 'containers/error/notify';
import FooterContainer from 'containers/footer';

const ErrorPageOffer = () => {
  return (
    <>
      <HeaderContainer />
      <ErrorContainerNotify />
      <FooterContainer />
    </>
  );
};

export default ErrorPageOffer;
